import Vue from 'vue';
import VueRouter from 'vue-router';
import home from "./routes/home";
import startInquiry from "./routes/start-inquiry";
import sendInquiry from './routes/send-inquiry';
import inquiry from "./routes/inquiry";
import userRoutes from './routes/user';
import notFound from './routes/404';
import privacyStatement from "./routes/privacy-statement";
import disclaimer from "./routes/disclaimer";
import copyright from "./routes/copyright";

Vue.use(VueRouter);
export default new VueRouter({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => ({y:0}),
    routes: [
        ...home,
        ...startInquiry,
        ...sendInquiry,
        ...inquiry,
        ...userRoutes,
        ...notFound,
        ...privacyStatement,
        ...disclaimer,
        ...copyright
    ]
})
